var _defs, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClutch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 170.39999",
    width: 600,
    height: 170.39999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t.st0{fill:#17313B;}\n\t.st1{fill:#EF4335;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g6",
    transform: "translate(-21,-235.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 177,235.9 h 27.6 V 406.3 H 177 Z",
    id: "path1",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 300.6,352.3 c 0,26.4 -21.6,28.8 -28.8,28.8 -16.8,0 -19.2,-15.6 -19.2,-24 v -66 H 225 v 64.8 c 0,15.6 4.8,30 14.4,38.4 8.4,8.4 19.2,12 32.4,12 9.6,0 21.6,-2.4 28.8,-9.6 v 9.6 h 27.6 V 291.1 h -27.6 z",
    id: "path2",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 382.2,249.1 h -27.6 v 42 h -20.4 v 26.4 h 20.4 v 88.8 h 27.6 v -88.8 h 20.4 v -26.4 h -20.4 z",
    id: "path3",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 489,371.5 c -6,4.8 -14.4,8.4 -22.8,8.4 -19.2,0 -32.4,-14.4 -32.4,-33.6 0,-19.2 13.2,-32.4 32.4,-32.4 8.4,0 16.8,2.4 22.8,8.4 l 3.6,3.6 19.2,-18 -4.8,-3.6 c -10.8,-9.6 -25.2,-15.6 -40.8,-15.6 -33.6,0 -58.8,25.2 -58.8,58.8 0,33.6 25.2,58.8 58.8,58.8 15.6,0 30,-6 40.8,-15.6 l 4.8,-3.6 -19.2,-19.2 z",
    id: "path4",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 609,300.7 c -8.4,-8.4 -16.8,-12 -30,-12 -9.6,0 -19.2,2.4 -26.4,9.6 V 235.9 H 525 v 170.4 h 27.6 v -63.6 c 0,-26.4 18,-28.8 25.2,-28.8 16.8,0 15.6,15.6 15.6,24 v 67.2 H 621 v -66 c 0,-15.6 -3.6,-30 -12,-38.4 z",
    id: "path5",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 465,
    cy: 347.5,
    r: 19.200001,
    id: "circle5",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 138.6,364.3 c -9.6,9.6 -24,15.6 -39.6,15.6 -30,0 -51.6,-24 -51.6,-56.4 0,-32.4 21.6,-56.4 52.8,-56.4 14.4,0 28.8,6 39.6,16.8 l 3.6,3.6 18,-18 -3.6,-3.6 c -15.6,-15.6 -36,-24 -57.6,-24 -45.6,-1.2 -79.2,34.8 -79.2,81.6 0,46.8 33.6,82.8 78,82.8 21.6,0 43.2,-8.4 57.6,-24 l 3.6,-3.6 -18,-18 z",
    id: "path6",
    style: {
      fill: "#ffffff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutch);
export default __webpack_public_path__ + "static/media/clutch.af77a97450a64aa87e037afccb8886cc.svg";
export { ForwardRef as ReactComponent };